import axios from 'axios';
import { REPORT_FCI_ACTION, REPORT_FCI_ENDPOINT } from './ReportFCIConstants';
import { NETWORK } from '../../App/AppConstants';
import { inIframe } from '../../App/AppUtils';
import _ from 'lodash';

const reportedFcis = [];

function isReportedFci(fciPayload) {
    try {
        return reportedFcis.some(fci => _.isEqual(fci, fciPayload));
    } catch (e) {
        capeLog && capeLog('Error in isReportedFci()', e);
    }
    return false;
}

/**
 * POST information about a client side FCI (Failed Customer Interaction). This
 * method does not need to return any data to continue.
 */
export const reportFCI = () => {
    return (dispatch, getState) => {
        const { serverData = {}, fci } = getState();
        const { _csrf = '', errorModel = {} } = serverData;
        const fciPayload = {
            ...errorModel,
            is_iframe: inIframe()
        };

        if (!isReportedFci(fciPayload)) {
            axios.request({
                method: 'POST',
                url: REPORT_FCI_ENDPOINT,
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data: fciPayload
            });

            reportedFcis.push(fciPayload);
        } else {
            capeLog && capeLog('duplicate reportFCI');
        }

        return dispatch({
            type: REPORT_FCI_ACTION,
            payload: fciPayload
        });
    };
};
